import { isFreshwaterTank } from '../first-run.js';

// The Tank tab (owner, 2026-10-21): everything about this tank that is not
// the daily view, one tap each. It took Dose and Supplies off the bottom
// bar and the settings gear out of the header. A new feature gets a row
// here, never a new tab or a Home section (CLAUDE.md, "Don't crowd the
// app").
export function tankRows(tank) {
  const fresh = isFreshwaterTank(tank);
  const owner = !tank?.role || tank.role === 'owner';
  return [
    { k: 'supplies', title: 'Supplies', sub: 'What is left, and when to reorder' },
    {
      k: 'dose',
      title: 'Dosing',
      sub: fresh ? 'Every dose you logged' : 'The dose calculator and every dose you logged',
    },
    // Third, above the fold on a phone: it took the header's settings gear.
    {
      k: 'settings',
      title: 'Tank settings',
      sub: owner
        ? 'Tests and ranges, units, sharing, sitter mode, export'
        : "The tank's setup, and export",
    },
    {
      k: 'equipment',
      title: 'Equipment and devices',
      sub: fresh
        ? 'Filter, heater, lighting, pumps, and connected devices'
        : 'Skimmer, pumps, RO/DI, lighting, and connected devices',
    },
    {
      k: 'livestock',
      title: 'Livestock',
      sub: fresh ? 'Fish, shrimp and snails in this tank' : 'Fish, corals and inverts in this tank',
    },
    { k: 'journal', title: 'Journal', sub: 'Your notes and photos, newest first' },
    {
      k: 'trends',
      title: 'Test history',
      sub: 'Every test charted, and past readings to bring in',
    },
    { k: 'icp', title: 'ICP results', sub: 'Lab reports and what changed between them' },
    { k: 'treatments', title: 'Quarantine and treatment', sub: 'Courses, their log and photos' },
    { k: 'history', title: 'Past residents', sub: 'Their journey, kept after they leave' },
  ];
}

export function TankView({ tank, onOpen }) {
  return (
    <div className="tv-page">
      {/* The tank's own name: from the tanks grid, Tank opens the last tank
        used, and supplies for a QT must not read as the display's. */}
      <h2 className="font-heading tv-title">{tank.name || 'This tank'}</h2>
      <ul className="tv-rows">
        {tankRows(tank).map((r) => (
          <li key={r.k}>
            <button type="button" className="tv-row" onClick={() => onOpen(r.k)}>
              <span className="tv-row-text">
                <span className="tv-row-title">{r.title}</span>
                <span className="tv-row-sub">{r.sub}</span>
              </span>
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--text-dim)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
